/**
 * KOMPA 2.0 — Single Source of Truth for financial constants.
 * ALL components must import from here. Never redeclare these values.
 */

export const FREQUENCIES = [
  { id: 'diario', label: 'Diario', plural: 'diarios', multiplier: 30 },
  { id: 'semanal', label: 'Semanal', plural: 'semanales', multiplier: 4.33 },
  { id: 'quincenal', label: 'Quincenal', plural: 'quincenales', multiplier: 2 },
  { id: 'mensual', label: 'Mensual', plural: 'mensuales', multiplier: 1 },
];

export const FREQ_LABELS = {
  diario: 'Diario', semanal: 'Semanal', quincenal: 'Quincenal', mensual: 'Mensual',
};

export const FREQ_MAP = { diario: 30, semanal: 4.33, quincenal: 2, mensual: 1 };
export const FREQ_DIVISOR = { diario: 30, semanal: 4, quincenal: 2, mensual: 1 };

export const TIME_OPTIONS = [1, 3, 6, 12, 18, 24, 36];

export const PHONE_PREFIXES = ['0412', '0414', '0416', '0422', '0424', '0426'];

export const CATEGORIES = [
  { id: 'motos', label: 'Motos', subtitle: 'Tu libertad en dos ruedas', icon: 'Bike' },
  { id: 'vehiculos', label: 'Vehículos', subtitle: 'Resguarda tu camino', icon: 'Car' },
  { id: 'ferreteria', label: 'Ferretería', subtitle: 'No es solo una casa, es tu hogar', icon: 'Hammer' },
  { id: 'educacion', label: 'Educación', subtitle: 'Planifica el progreso', icon: 'GraduationCap' },
  { id: 'navidades', label: 'Navidades', subtitle: 'Anticípate a las fiestas', icon: 'Gift' },
  { id: 'salud', label: 'Salud', subtitle: 'Bienestar y cuidado', icon: 'HeartPulse' },
  { id: 'tecnologia', label: 'Tecnología', subtitle: 'Innovación a tu alcance', icon: 'Monitor' },
  { id: 'viajes', label: 'Viajes', subtitle: 'Explora el mundo', icon: 'Plane' },
  // Generic savings goal — for users who only want to save without a fixed product in mind.
  { id: 'dinero', label: 'Dinero', subtitle: 'Ahorra sin un fin predeterminado', icon: 'Banknote' },
];

/**
 * Catálogo oficial de bancos venezolanos activos para Pago Móvil y Débito
 * Inmediato (alineado con la lista provista por Operaciones — abril 2026).
 * Formato: "Nombre - CCCC" donde CCCC es el código bancario de 4 dígitos.
 */
export const BANKS = [
  'Banco de Venezuela (BDV) - 0102',
  'Venezolano de Crédito (BVC) - 0104',
  'Mercantil - 0105',
  'Provincial (BBVA) - 0108',
  'Bancaribe - 0114',
  'Banco Exterior - 0115',
  'BOD - 0116',
  'Banco Caroní - 0128',
  'Banesco - 0134',
  'Banco Plaza - 0138',
  'BFC (Banco Fondo Común) - 0151',
  '100% Banco - 0156',
  'Del Sur - 0157',
  'Banco del Tesoro - 0163',
  'Banco Agrícola de Venezuela - 0166',
  'Bancrecer - 0168',
  'Mi Banco - 0169',
  'Banco Activo - 0171',
  'Bancamiga - 0172',
  'Banplus - 0174',
  'Bicentenario - 0175',
  'Banfanb (Fuerza Armada) - 0177',
  'BNC (Nacional de Crédito) - 0191',
];

export const CEDULA_PREFIXES = ['V', 'E', 'J', 'P', 'G'];

export const BS_RATE_FALLBACK = 565.00;

// ── Feature Flags ────────────────────────────────────────────────────────
/**
 * OTP_SMS_ENABLED — Controls the phone OTP verification step on
 * `ProfileView.jsx` (KYC). Currently disabled because no SMS provider is
 * contracted. When set to `true`:
 *   • The "Validar" button next to the phone field reappears.
 *   • The ValidationModal for phone is reachable again.
 *   • Backend `kyc.py::_compute_kyc_completed` requires `phone_validated`
 *     (the env var `OTP_SMS_ENABLED=true` toggles the server-side counterpart).
 * While disabled, KYC completes with email + cédula + terms only.
 */
export const OTP_SMS_ENABLED = false;

/**
 * RIF_REQUIRED — Controls whether RIF upload is mandatory to complete KYC.
 * When `false` (default), RIF is OPTIONAL: the UI shows it as "(opcional)"
 * and the user can still finish KYC and make payments without uploading
 * it. The RIF upload button stays active so the user can upload the
 * document at any time. The backend env var `RIF_REQUIRED=true` must be
 * flipped in parallel to make it mandatory again.
 */
export const RIF_REQUIRED = false;

// Welcome onboarding video — shown on the first goal-creation screen.
// The video auto-plays muted, the controls are hidden, and the
// `onEnded` event advances the user to the category step.
export const WELCOME_VIDEO_URL = 'https://customer-assets.emergentagent.com/job_35fbdbab-013c-45c7-a663-24f0d9e97ca8/artifacts/1h32nq44_hf_20260430_005718_85c310b3-c8a4-4c4b-bfff-a4c37edb1186.mp4';
